export const PromotionsType = {
	NextDepositMatch: 1,
	RacingBonusBack: 2,
	SportsBonusBack: 3,
	SGMBonusBack: 4,
	RacingMultiBonusBack: 5,
	SportMultiBonusBack: 6,
	SRMBonusBack: 7,
	RacingCashBack: 8,
	SportsCashBack: 9,
	SGMCashBack: 10,
	RacingMultiCashBack: 11,
	SportMultiCashBack: 12,
	SRMCashBack: 13
};

export const PromotionsTypeNames = {
	[PromotionsType.NextDepositMatch]: 'Next Deposit Match',
	[PromotionsType.RacingBonusBack]: 'Racing Bonus Back',
	[PromotionsType.SportsBonusBack]: 'Sports Bonus Back',
	[PromotionsType.SGMBonusBack]: 'SGM Bonus Back',
	[PromotionsType.RacingMultiBonusBack]: 'Racing Multi Bonus Back',
	[PromotionsType.SportMultiBonusBack]: 'Sport Multi Bonus Back',
	[PromotionsType.SRMBonusBack]: 'SRM Bonus Back',
	[PromotionsType.RacingCashBack]: 'Racing Cash Back',
	[PromotionsType.SportsCashBack]: 'Sports Cash Back',
	[PromotionsType.SGMCashBack]: 'SGM Cash Back',
	[PromotionsType.RacingMultiCashBack]: 'Racing Multi Cash Back',
	[PromotionsType.SportMultiCashBack]: 'Sport Multi Cash Back',
	[PromotionsType.SRMCashBack]: 'SRM Cash Back'
};

export const RewardType = {
	Boost: 1,
	Promotion: 2
};

export const BonusLimits = [
	{ value: 2000, label: '$20' },
	{ value: 2500, label: '$25' },
	{ value: 3000, label: '$30' },
	{ value: 4000, label: '$40' },
	{ value: 5000, label: '$50' },
	{ value: 6000, label: '$60' },
	{ value: 6250, label: '$62.50' },
	{ value: 7000, label: '$70' },
	{ value: 7500, label: '$75' },
	{ value: 8000, label: '$80' },
	{ value: 10000, label: '$100' },
	{ value: 12000, label: '$120' },
	{ value: 12500, label: '$125' },
	{ value: 14000, label: '$140' },
	{ value: 15000, label: '$150' },
	{ value: 17500, label: '$175' },
	{ value: 18750, label: '$187.50' },
	{ value: 20000, label: '$200' },
	{ value: 22500, label: '$225' },
	{ value: 24000, label: '$240' },
	{ value: 25000, label: '$250' },
	{ value: 30000, label: '$300' },
	{ value: 35000, label: '$350' },
	{ value: 37500, label: '$375' },
	{ value: 40000, label: '$400' },
	{ value: 45000, label: '$450' },
	{ value: 50000, label: '$500' },
	{ value: 52500, label: '$525' },
	{ value: 56250, label: '$562.50' },
	{ value: 60000, label: '$600' },
	{ value: 62500, label: '$625' },
	{ value: 70000, label: '$700' },
	{ value: 75000, label: '$750' },
	{ value: 80000, label: '$800' },
	{ value: 90000, label: '$900' },
	{ value: 100000, label: '$1,000' },
	{ value: 112500, label: '$1,125' },
	{ value: 120000, label: '$1,200' },
	{ value: 125000, label: '$1,250' },
	{ value: 140000, label: '$1,400' },
	{ value: 145000, label: '$1,450' },
	{ value: 150000, label: '$1,500' },
	{ value: 175000, label: '$1,750' },
	{ value: 187500, label: '$1,875' },
	{ value: 200000, label: '$2,000' },
	{ value: 240000, label: '$2,400' },
	{ value: 250000, label: '$2,500' },
	{ value: 300000, label: '$3,000' },
	{ value: 350000, label: '$3,500' },
	{ value: 375000, label: '$3,750' },
	{ value: 395000, label: '$3,950' },
	{ value: 400000, label: '$4,000' },
	{ value: 450000, label: '$4,500' },
	{ value: 500000, label: '$5,000' },
	{ value: 600000, label: '$6,000' },
	{ value: 625000, label: '$6,250' },
	{ value: 700000, label: '$7,000' },
	{ value: 750000, label: '$7,500' },
	{ value: 800000, label: '$8,000' },
	{ value: 900000, label: '$9,000' },
	{ value: 1000000, label: '$10,000' },
	{ value: 1050000, label: '$10,500' },
	{ value: 1125000, label: '$11,250' },
	{ value: 1200000, label: '$12,000' },
	{ value: 1250000, label: '$12,500' },
	{ value: 1400000, label: '$14,000' },
	{ value: 1500000, label: '$15,000' },
	{ value: 1600000, label: '$16,000' },
	{ value: 1750000, label: '$17,500' },
	{ value: 1800000, label: '$18,000' },
	{ value: 1875000, label: '$18,750' },
	{ value: 2000000, label: '$20,000' },
	{ value: 2100000, label: '$21,000' },
	{ value: 2250000, label: '$22,500' },
	{ value: 2400000, label: '$24,000' },
	{ value: 2500000, label: '$25,000' },
	{ value: 2700000, label: '$27,000' },
	{ value: 2800000, label: '$28,000' },
	{ value: 3000000, label: '$30,000' },
	{ value: 3200000, label: '$32,000' },
	{ value: 3500000, label: '$35,000' },
	{ value: 3600000, label: '$36,000' },
	{ value: 3750000, label: '$37,500' },
	{ value: 4000000, label: '$40,000' },
	{ value: 4200000, label: '$42,000' },
	{ value: 4500000, label: '$45,000' },
	{ value: 4800000, label: '$48,000' },
	{ value: 4900000, label: '$49,000' },
	{ value: 5000000, label: '$50,000' },
	{ value: 5250000, label: '$52,500' },
	{ value: 5400000, label: '$54,000' },
	{ value: 6000000, label: '$60,000' },
	{ value: 6300000, label: '$63,000' },
	{ value: 6750000, label: '$67,500' },
	{ value: 7000000, label: '$70,000' },
	{ value: 8000000, label: '$80,000' },
	{ value: 9000000, label: '$90,000' },
	{ value: 10000000, label: '$100,000' },
	{ value: 12000000, label: '$120,000' },
	{ value: 70000000, label: '$700,000' },
	{ value: 75000000, label: '$750,000' }
];
